module.exports = __webpack_public_path__ + "static/posta-6d6fdecd557d0e20dd32c50d2175a9c0.jpg";